import { render, staticRenderFns } from "./GenderPolarChart.vue?vue&type=template&id=5fc061a6&"
import script from "./GenderPolarChart.vue?vue&type=script&lang=js&"
export * from "./GenderPolarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports